import React from "react";
import { Helmet } from "react-helmet-async";
import PropTypes from "prop-types";

const FAQStructuredData = ({ questions }) => {
    const FAQData = (questions || []).map((item) => ({
        "@type": "Question",
        name: item.title,
        acceptedAnswer: {
            "@type": "Answer",
            text: item.text,
        },
    }));

    const FAQPage = {
        "@context": "https://schema.org",
        "@type": "FAQPage",
        mainEntity: FAQData,
    };

    return FAQData.length ? (
        <Helmet>
            <script type="application/ld+json">{JSON.stringify(FAQPage, null, 2)}</script>
        </Helmet>
    ) : null;
};

FAQStructuredData.propTypes = {
    questions: PropTypes.array.isRequired,
};

export default FAQStructuredData;
